import angular from 'angular';
 import trackingComponent from './tracking.component';
 import TrackingService from './tracking.service';
 import trackingConfig from './tracking.confing';

let trackingModule = angular.module('app.tracking',[])
  .component('tracking', trackingComponent)
   .service('TrackingService', TrackingService)
   .config(trackingConfig)
  ;

export default trackingModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/orders/tracking/tracking.js
 **/